<template>
<tfoot  v-if="paginator.last_page > 1">
  <tr>
    <th colspan="4">
      <div class="ui right floated pagination menu" style="flex-wrap: wrap; justify-content: center;">
        <router-link v-if="paginator.current_page != 1" :to="{ name: goTo.name, params: Object.assign({}, goTo.params, { page: paginator.current_page - 1 }) }" class="icon item">
          <i class="left chevron icon"></i>
        </router-link>
        <router-link v-for="(link, index) in paginator.last_page" :to="{ name: goTo.name, params: Object.assign({}, goTo.params, { page: index + 1 }) }" v-bind:class="{ 'active': paginator.current_page == index+1}" class="item">{{index+1}}</router-link>
        <router-link v-if="paginator.last_page != paginator.current_page" :to="{ name: goTo.name, params: Object.assign({}, goTo.params, { page: paginator.current_page + 1 }) }" class="icon item">
          <i class="right chevron icon"></i>
        </router-link>
      </div>
    </th>
  </tr>
</tfoot>
</template>

<script>
export default {
  computed: {
    goTo() {
      var result = {};
      
      var categoryLink = this.$route.params.categorylink ? this.$route.params.categorylink : '';
      var categoryaLink = this.$route.params.categoryalink ? this.$route.params.categoryalink : '';
      var categorybLink = this.$route.params.categoryblink ? this.$route.params.categoryblink : '';
      
      if (categorybLink != '' && categoryaLink != '' && categoryLink != '') {
        result.name = 'goods-categoryb-page-n';
        result.params = { categorylink: categoryLink, categoryalink: categoryaLink, categoryblink: categorybLink };
      } else if (categoryaLink != '' && categoryLink != '') {
        result.name = 'goods-categorya-page-n';
        result.params = { categorylink: categoryLink, categoryalink: categoryaLink };
      } else if (categoryLink != '') {
        result.name = 'goods-category-page-n';
        result.params = { categorylink: categoryLink };
      } else {
        result.name = 'goods-page';
		result.params = {};
      }
	  
	  return result;
    },
  },
  props: ['paginator']
}
</script>



// WEBPACK FOOTER //
// GoodsPaginator.vue?c27925a4